"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _TileContent = _interopRequireDefault(require("./_TileContent"));

var _TileFooter = _interopRequireDefault(require("./_TileFooter"));

var _TileHeader = _interopRequireDefault(require("./_TileHeader"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _tile = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/tile.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _tile.default);
/** A **Tile** can be used to represent an app similar to the SAP Fiori launchpad home page.
 * They can display different types of content, which are based on the data supplied by the app.
 * They can contain an icon, a title, an informative text, KPIs, counters and charts. */

var Tile = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _context, _classnames;

  var disabled = _ref.disabled,
      backgroundImage = _ref.backgroundImage,
      children = _ref.children,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      isDouble = _ref.isDouble,
      onClick = _ref.onClick,
      size = _ref.size,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["disabled", "backgroundImage", "children", "className", "cssNamespace", "isDouble", "onClick", "size"]);
  var tileClasses = classnames("".concat(cssNamespace, "-tile"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, (0, _concat.default)(_context = "".concat(cssNamespace, "-tile--")).call(_context, size), size === 's'), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-tile--double"), isDouble), (0, _defineProperty2.default)(_classnames, 'is-disabled', disabled), _classnames), className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rest, {
    className: tileClasses,
    onClick: onClick,
    ref: ref,
    role: "button",
    tabIndex: "0"
  }), children);
});

Tile.displayName = 'Tile';
process.env.NODE_ENV !== "production" ? Tile.propTypes = {
  /** Callback function when user clicks on the component*/
  onClick: _propTypes.default.func.isRequired,

  /** URL of the background image for product tile */
  backgroundImage: _propTypes.default.string,

  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Set to **true** to increase tile dimensions to 2x1 */
  isDouble: _propTypes.default.bool,

  /** Default tiles are designed for screens larger than 374px. For smaller screens use 's' */
  size: _propTypes.default.oneOf(['s'])
} : void 0;
Tile.Content = _TileContent.default;
Tile.Header = _TileHeader.default;
Tile.Footer = _TileFooter.default;

var _default = (0, _withStyles.default)(Tile);

exports.default = _default;